import TestCard from './TestCard';
import NoItems from './NoItems';
import { checkCircleFill, lockPadDot, noTestData } from '../../../constants/icons';
import { format } from "date-fns";
import { courseMaterialUrl } from '../../../../helpers/url_helper';

function timeSplit(time, options = 'hm')
{
  /* hm Hour - Minute | ms Minute - Second */
  const [frontKey, secondKey ] = time.split(":").map(Number); // Split and convert to numbers
  const  total = parseInt(frontKey * 60 + secondKey, 10);
  if (options === 'ms') {
    const minutes = parseInt(frontKey, 10); // Extract minutes
    const seconds = parseInt(secondKey, 10); // Extract seconds
    return (total > 60) ? `${minutes} mins, ${seconds}s` : `${total}s`;
  }
  return total + 'm';
}

export default function TestJourney(props) {
  const { sections, lectures, slug } = props;

  const testJourneyData = sections.map((section) => {
    const relatedTest = lectures
      .filter((lecture) => lecture.cl_section_id === section.id && lecture.cl_lecture_type === 3)
      .map((lecture) => ({
        testStatus: lecture.attempted === false ? 'notstarted' : 'completed',
        date: Object.keys(lecture.attempt_data).length > 0 ? format(new Date(lecture.attempt_data.aa_created_time), "MMM dd yyyy, h:mma") : 'Not started yet',
        title: lecture.cl_lecture_name,
        questionOrMarks: lecture.a_data.a_questions > 0 && lecture.a_data.a_mark > 0 ? 'Questions / Total Marks' : 
                        lecture.a_data.a_questions > 0 ? 'Questions' : 'Total Marks',
        questions: lecture.a_data.a_questions > 0 && lecture.a_data.a_mark > 0 ? `${lecture.a_data.a_questions} Questions ${lecture.a_data.a_mark} Marks` : 
                  lecture.a_data.a_questions > 0 ? lecture.a_data.a_questions : lecture.a_data.a_mark,
        marksScored: Object.keys(lecture.attempt_data).length > 0 ?  lecture.attempt_data.aa_mark_scored : '-',
        totalMarks: Object.keys(lecture.a_data).length > 0 ?  lecture.a_data.a_mark : '-',
        duration: Object.keys(lecture.attempt_data).length > 0 ?  timeSplit(lecture.attempt_data.aa_duration,'ms') : '-',
        totalDuration: Object.keys(lecture.a_data).length > 0 ?  timeSplit(lecture.a_data.a_duration, 'hm') : '-',
        grade: Object.keys(lecture.attempt_data).length > 0 ? lecture.attempt_data.aa_grade : '-',
        icon: Object.keys(lecture.attempt_data).length > 0 ? checkCircleFill : lockPadDot,
        courseId: lecture.cl_course_id,
        lectureId: lecture.cl_id,
        slug: slug,
        attemptData: lecture?.attempted ? lecture?.attempt_data : ''
      }))
    
    return {
      title: section.s_name,
      data: relatedTest,
    };
  });
  
  const finalData = testJourneyData.filter((section) => section.data.length > 0);

  return (
    <div className="mky__stu-course_test-wrapper">
      {finalData.length > 0 ? (
      finalData.map((section, index) => (
      <>
      <h2>{`Section ${index + 1 } : ${ section.title}`}</h2>
      <ul className="course_test-content_list">
        {section.data.map((test, index) => (
          <li key={index} className={`test-item ${test.testStatus === 'completed' ? 'completed' : 'notstarted'}`}>
            <TestCard 
              testStatus={test.testStatus}
              date={test.date}
              title={test.title}
              questions={test.questions}
              marksScored={test.marksScored}
              totalMarks={test.totalMarks}
              duration={test.duration}
              totalDuration={test.totalDuration}
              grade={test.grade}
              icon={test.icon}
              courseId={test.courseId}
              lectureId={test.lectureId}
              slug={slug}
              attemptData={test.attemptData}
            />
          </li>
        ))}
      </ul>
      </>
      ))
      ):(
        <div className="w-100">
          <h2>Test Journey</h2>
          <NoItems
            icon={noTestData}
            title="No Test Journey to show!"
            description="This course is all about learning for fun--no tests and no grades, just good vibes and knowledge!"
          />
        </div>
      )}
    </div>
  );
}
